import {
  AfterViewInit,
  ApplicationRef,
  Component,
  createComponent,
  ElementRef,
  EnvironmentInjector,
  Inject,
  Injector, OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';
import {PinchZoomWrapperComponent} from '../pinch-zoom-wrapper/pinch-zoom-wrapper.component';
import {environment} from '../../../environments/environment';
import {Subscription} from "rxjs";

@Component({
    selector: 'mbnm-help-detail',
    templateUrl: './help-detail.component.html',
    styleUrls: ['./help-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HelpDetailComponent implements OnInit, AfterViewInit, OnDestroy {
  constructor(private route: ActivatedRoute,
              private http: HttpClient,
              @Inject(DOCUMENT) private document: Document,
              @Inject(PLATFORM_ID) private platformId: Object,
              private injector: Injector,
              private environmentInjector: EnvironmentInjector,
              private applicationRef: ApplicationRef,
  ) {
  }

  @ViewChild('content') content: ElementRef;
  public html: string;
  private fragment: string;

  private routeSubRef: Subscription;
  private fragSubscription: Subscription;
  private getTemplateSubRef: Subscription;

  ngOnInit() {
    this.routeSubRef = this.route.url
      .subscribe(url => {
        this.getTemplateSubRef = this.http
          .get('/assets/templates/help/' + url[0].path + '.html', {responseType: 'text'})
          .subscribe( (data: string) => {
            this.html = data;
            if (isPlatformBrowser(this.platformId)) {
              setTimeout(() => {
                const els = this.content.nativeElement.getElementsByClassName('zoom');
                for (let i = 0; i < els.length; i++) {
                  const pz = this.document.createElement('pinch-zoom-container');
                  const pzComponentRef = createComponent(PinchZoomWrapperComponent, {
                    environmentInjector: this.environmentInjector,
                    elementInjector: this.injector,
                    hostElement: pz
                  });
                  pzComponentRef.instance.content = els[i].innerHTML;
                  this.applicationRef.attachView(pzComponentRef.hostView);
                  els[i].replaceChild(pz.firstChild, els[i].firstElementChild);
                }

                const anchors = this.content && this.content.nativeElement.getElementsByTagName('a');
                if (anchors) {
                  for (let i = 0; i < anchors.length; i++) {
                    const anchor = anchors[i];
                    const href = anchor.attributes['href'] != null && anchor.attributes['href'].value ? anchor.attributes['href'].value : '';
                    if (href.startsWith('http') === false) {
                      anchor.href = environment.baseUrls().site + href;
                    }
                  }
                }
              }, 0);
            }
          });
      });

    this.fragSubscription = this.route.fragment
      .subscribe(fragment => {
        this.fragment = fragment;
        setTimeout(() => {
          this.scrollFragmentIntoViewIfNecessary();
        }, 0);
      });
  }

  ngOnDestroy() {
    if (this.routeSubRef && !this.routeSubRef.closed) {
      this.routeSubRef.unsubscribe();
    }

    if (this.fragSubscription && !this.fragSubscription.closed) {
      this.fragSubscription.unsubscribe();
    }

    if (this.getTemplateSubRef && !this.getTemplateSubRef.closed) {
      this.getTemplateSubRef.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.scrollFragmentIntoViewIfNecessary();
    }, 0);
  }

  scrollFragmentIntoViewIfNecessary(): void {
    if (this.fragment) {
      try {
        const el = document.querySelector('#' + this.fragment);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth'});
        }
      } catch (e) { }
    }
  }
}
